class BESSAppProjectEnergyDetailsGasSupplyEditorManager extends BESSAppProjectEditorManagerBase {

    constructor(editor) {
        super(editor);
        this.gasSupplyInput = editor.input.gasSupply;
        this.gasSupplyInputConfirming = false;
        this.gasSupply = this.gasSupplyInput.value.value;
        this.gasSupplyInput.addChangeRule(this.#onGasSupplyChanged.bind(this))
    }


    #onGasSupplyChanged(value) {
        if (value != null && value.key === "1") {
            if (this.gasSupplyInputConfirming) {
                return;
            }
            this.gasSupplyInputConfirming = true;
            this.askUserToConfirm(
                "Energy Supply",
                "Are you sure? Under Victorian planning provisions introduced 1 January 2024, new dwellings and new apartment developments are prohibited from connecting to a reticulated gas service.",
                this.#onConfirmChangeGasSupply.bind(this),
                "Yes - I'm sure",
                "No - undo selection",
                this.#onDismissChangeGasSupply.bind(this)
            );
            return false;
        }
        if (value != null && value.key === "4") {
            if (this.gasSupplyInputConfirming) {
                return;
            }
            this.gasSupplyInputConfirming = true;
            this.askUserToConfirm(
                "Energy Supply",
                "Confirm Electricity & Wood development? Any gas appliance options will be deselected.",
                this.#onConfirmChangeGasSupply.bind(this),
                "Yes - I'm sure",
                "No - undo selection",
                this.#onDismissChangeGasSupply.bind(this)
            );
            return false;
        }
        this.gasSupply = this.gasSupplyInput.value.value;
        //return false;
        return true;
    }

    #onConfirmChangeGasSupply() {
        this.showDoingWork('Energy Supply', 'Applying gas supply change to project');
        this.editor.inputValueChanged(this.gasSupplyInput);
        setTimeout(function () {
            window.location.reload();
        }, 2000);
    }

    #onDismissChangeGasSupply() {
        this.gasSupplyInput.setValue({key: this.gasSupply});
        this.gasSupplyInputConfirming = false;
    }
}